(function($){

// ---------- APP START
var App = {
	
  config: {
		scrollOffset: 100
  },
	
	init: function(){
    $.fn.matchHeight._maintainScroll = true;

    // Init SVG polyfill
    if(typeof(svg4everybody) !== 'undefined') svg4everybody();

    // Init object-fill polyfill
    if(typeof(objectFitImages) !== 'undefined') objectFitImages();

    // Remove focus state when clicking on a button with a mouse
    $(':not(form) button, a').on('click', function(e){
      if(e.clientX && e.clientY)
        $(this).blur();
    });
		
    $('a[href^="#"]').on('click', function(e){
      e.preventDefault();
      var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');
						
      if($(scrollTo).length > 0 && ($(this).data('prevent-scroll') !== true) && !$(this).data('vc-container')) {
        App.scroll(scrollTo, $(this).data('scroll-offset'));			
			}
    });

    if($('[data-scroll]').length){
      App.scroll($('[data-scroll]').data('scroll'));
    }

    if($('.form-field').length){
      $('.form-field__input')
        .on('focus', function(){ $(this).removeClass('m--error').closest('.form-field').addClass('is-active'); })
        .on('blur', function(){ if($(this).val().length === 0) $(this).closest('.form-field').removeClass('is-active'); })
        .each(function(){
          if($(this).val().length !== 0){
            $(this).closest('.form-field').addClass('is-active');
          }
        });
    }
		
		if($('.header'.length)) $('.header').header();
		if($('.counter').length) App.initCounts();
		if($('.js-mfp-brands').length) App.mfp.initMfpBrands();

    window.addEventListener("popstate", function(e) {
      window.location.reload();
    });
  },

  load: function(){
  },
	
  scroll: function(element, offset){
    offset = offset === undefined ? App.config.scrollOffset : offset;
    $('html, body').animate({ scrollTop: $(element).offset().top - offset}, 'slow');
  },
	
	// Init networks totals
	initCounts: function() {
		$('.counter').each(function() {
			var count = $(this),
				decimal = (count.text().indexOf('.') !== -1) ? true : false,
				unit = (count.text().indexOf(' ') !== -1) ? count.text().substring(count.text().indexOf(' ') + 1, count.text().length) : false,
        to = (unit !== false) ? count.text().substring(0, count.text().indexOf(' ')) : count.text(),
				performed = false,
				viewport = {},
				bounds = {};

			bounds.top = count.offset().top;
			bounds.bottom = bounds.top + count.outerHeight();

			performAnimation();

			$(window).on('scroll resize', performAnimation);

			function performAnimation() {
				viewport.top = $(window).scrollTop();
				viewport.bottom = viewport.top + $(window).height();

				if (performed === false && bounds.top <= viewport.bottom && bounds.bottom >= viewport.top) {
					count.prop('counter', 0).animate({
						counter: to
					}, {
						duration: 1500,
						step: function(now) {
							var value = (decimal !== false) ? now.toString().substring(0, now.toString().indexOf('.') + 2) : Math.ceil(now);
							if (unit !== false) { value += ' ' + unit;	}
							count.text(value);
						}
					});
					performed = true;
				}
			}
		});
	},
	
	mfp: {
				
		initMfpBrands: function(){		
			$('.js-mfp-brands').magnificPopup({
				type: 'ajax',
				preloader: false,
				mainClass: 'mfp-brands-card',
				delegate: '.card-brand',
			});
		}
	},	
	
	
	Tac: function() {

    window.tarteaucitronForceLanguage = $('html').attr('lang');
    tarteaucitron.init({
      "hashtag": "#tac",
      "highPrivacy": false,
      "orientation": "bottom",
      "adblocker": false,
      "showAlertSmall": false,
      "cookieslist": true,
      "removeCredit": true
    });
		
		tarteaucitron.user.gtagUa = "UA-133360548-1";
    (tarteaucitron.job = tarteaucitron.job || []).push("gtag");
  },

  gtag: function(action, category, label, value) {
    if(window.gtag !== undefined) {
      window.gtag('event', action, {
        'event_category': category,
        'event_label': label,
        'value': value
      });
    }
  },
	
	tagManager: {		
		sendEvent: function(action, category, label, value) {			
			if(window.gtag !== undefined) {
				window.gtag ('event', action, {
					'event_category': category,
					'event_label': label,
					'value': value
				});	
			}
		},
	}

};
// ---------- APP END

// Init app
$(document).ready(App.init);
// $(window).load(App.load); // jQuery 2
$(window).on('load', App.load); // jQuery 3
window.App = App;
App.Tac();
})(jQuery);

// ---------- MISSING FUNCTIONS
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
// ---------- MISSING FUNCTIONS END
